import { render } from "./SplitPhaseDialog.vue?vue&type=template&id=2d5d83f0&scoped=true"
import script from "./SplitPhaseDialog.vue?vue&type=script&lang=js"
export * from "./SplitPhaseDialog.vue?vue&type=script&lang=js"

import "./SplitPhaseDialog.vue?vue&type=style&index=0&id=2d5d83f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5d83f0"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QForm,QIcon,QBtn});qInstall(script, 'directives', {ClosePopup});
